import { useWizardMaster } from '../../../../Contexts/WizardMasterContext'
import { useOrderContainersContext } from '../../../../Contexts/OrderContainersContext'
import { paneModes } from '../../../../../../constants/orderWizard'
import React from 'react'
import { GraviButton } from '@gravitate-js/excalibrr'

export const CancelButton = () => {
  const { setPaneMode, wizardOrder } = useWizardMaster()
  const { constructCompartments } = useOrderContainersContext()
  const cancelChanges = () => {
    constructCompartments(wizardOrder)
    setPaneMode(paneModes.TANKIMPACT)
  }
  return (
    <GraviButton
      className='navigate-back-button '
      buttonText='Cancel'
      appearance='outline'
      onClick={() => cancelChanges()}
    />
  )
}
